var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBovinosCarne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(10019 465)",
    fill: "#36364a",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10019 -465)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10018.071 461.166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.982,8.916a38.727,38.727,0,0,1,7.005.318A10.587,10.587,0,0,1,32.8,18.043c.425,2.76-.106,5.2-2.547,7.005a6.2,6.2,0,0,1-4.033,1.168H23.775a8.373,8.373,0,0,0-4.564,1.168,27.66,27.66,0,0,1-5.625,2.76,11.224,11.224,0,0,1-5.625.425,8.227,8.227,0,0,1-6.05-5.413,14.483,14.483,0,0,1-.425-9.234A8.119,8.119,0,0,1,8.7,9.552c2.441-.318,4.882-.425,7.323-.531h.955Zm-.425,1.592h-1.38c-2.017.106-4.033.212-6.05.425-3.609.531-5.625,2.547-6.368,6.05a12.308,12.308,0,0,0,.318,6.793c1.274,4.139,4.776,6.156,9.128,5.2a19.151,19.151,0,0,0,5.838-2.547,10.121,10.121,0,0,1,6.474-1.7H26.64a4.125,4.125,0,0,0,1.592-.212,5.063,5.063,0,0,0,3.5-5.413,9.353,9.353,0,0,0-7.642-8.491A33.83,33.83,0,0,0,16.77,10.4Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.518,23.35a14.258,14.258,0,0,0-3.715.318,21.2,21.2,0,0,0-4.458,2.017,14.882,14.882,0,0,1-5.519,1.91,5.512,5.512,0,0,1-4.988-1.8,10.111,10.111,0,0,1-1.8-8.173,6.192,6.192,0,0,1,5.095-5.413,42.957,42.957,0,0,1,6.368-.531c3.715,0,7.748-.637,11.038,1.486a8.174,8.174,0,0,1,3.29,4.245,5.215,5.215,0,0,1-.637,4.67c-1.061,1.168-2.972,1.274-4.564,1.168h0ZM17.3,13.267c-2.972.318-8.491-.318-10.508,1.91-2.547,2.76-2.017,9.977,2.123,10.932a7.84,7.84,0,0,0,3.821-.318c2.335-.743,4.352-2.229,6.581-3.078a12.135,12.135,0,0,1,3.4-.743c1.274-.106,2.653,0,3.821-.106,2.335-.318,2.441-2.76,1.592-4.564a6.693,6.693,0,0,0-5.944-3.927,18.8,18.8,0,0,0-4.882,0h0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.932,23.775c-.849,0-.849-.743,0-.955.955,0,1.061.849.106.955h-.106Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.161,23.775c-.531,0-.955-.531-.318-.849.318-.106.955,0,1.061.318,0,.318-.425.425-.637.425h0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.173,19.1l-1.592-.637a.442.442,0,0,1,0-.849,14.175,14.175,0,0,1,1.91-.743v-1.8a.705.705,0,0,1,.425-.531,1.414,1.414,0,0,1,.531.318,3.179,3.179,0,0,0,1.274,1.592,1.968,1.968,0,0,0,.743.212h.849A2.144,2.144,0,0,0,14.435,15.5a2.66,2.66,0,0,1,.425-.743c0-.106.318-.318.425-.318s.318.212.425.425v1.91a14.175,14.175,0,0,1,1.91.743c.212,0,.425.318.425.531,0,.106-.212.425-.425.425-.531.212-1.061.425-1.486.637a12.833,12.833,0,0,0-.531,1.91,11.963,11.963,0,0,0-.318,1.91,1.658,1.658,0,0,1-.849,1.592,4.6,4.6,0,0,1-4.67,0,1.579,1.579,0,0,1-.743-1.592A4.381,4.381,0,0,0,8.6,20.591,10.89,10.89,0,0,1,8.173,19.1Zm1.7,2.547a4.736,4.736,0,0,1,4.458,0l.637-1.592a1.76,1.76,0,0,0-1.592-2.441H10.932A1.817,1.817,0,0,0,9.34,20.166l.637,1.592ZM12.1,24.305a2.778,2.778,0,0,0,1.8-.531c.531-.425.531-.743,0-1.168a3.374,3.374,0,0,0-3.715,0c-.531.425-.531.849,0,1.168A2.9,2.9,0,0,0,12.1,24.305Zm4.245-6.262v-.106a3.1,3.1,0,0,1-.955-.212c.212.637.637.318.955.318Zm-8.491-.106c.318.212.743.425.849-.212a2.5,2.5,0,0,0-.849.212Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.531,
    cy: 0.531,
    r: 0.531,
    transform: "translate(10.614 18.468)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.531,
    cy: 0.531,
    r: 0.531,
    transform: "translate(12.418 18.468)",
    fill: "#36364a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBovinosCarne);
export default __webpack_public_path__ + "static/media/bovinos_carne.ee44980dfe368a93fed96b457969ca71.svg";
export { ForwardRef as ReactComponent };